/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SortOrder {
    ASCENDING = 'Ascending',
    DESCENDING = 'Descending',
}
